import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PANEL_TYPES } from '../../../shell/panel-state'
// Register the invoice panel plus the foreign panels the record page
// cross-references (company / contact / subscription) so they open in place.
import '../../../modules/companies/register-panels'
import '../../../modules/contacts/register-panels'
import '../../../modules/invoices/register-panels'
import '../../../modules/subscriptions/register-panels'
import { InvoiceFullPage } from '../../../modules/invoices/invoice-full-page'

const detailSearchSchema = z.object({
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
})

/** The full-page invoice record at /invoices/:id. */
export const Route = createFileRoute('/_authed/invoices/$invoiceId')({
  validateSearch: detailSearchSchema,
  component: InvoiceDetailRoute,
})

function InvoiceDetailRoute() {
  const { invoiceId } = Route.useParams()
  return <InvoiceFullPage invoiceId={invoiceId} />
}
